import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-conference-payment-logs',
  templateUrl: './conference-payment-logs.component.html',
  styleUrls: ['./conference-payment-logs.component.css']
})
export class ConferencePaymentLogsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
